import classNames from 'classnames';
import React from 'react';

import useFreeDeliveryThreshold from '@jpp/hooks/useFreeDeliveryThreshold';
import { ICartLineItem } from 'common/redux/wooCommerce/cart/reducer';

import './CartMessage.scss';

interface ICartMessageProps {
  className?: string;
  subtotal: string;
  cartLineItems: ICartLineItem[];
  freeDeliveryThreshold: string;
}

const ROOT_CLASSNAME = 'CartMessage';

const CartMessage: React.FunctionComponent<ICartMessageProps> = ({
  className,
  subtotal,
}) => {
  const { isLessThanZero, messaging } = useFreeDeliveryThreshold();

  return (
    <div
      className={classNames(ROOT_CLASSNAME, className, {
        [`${ROOT_CLASSNAME}--has-single-item`]: isLessThanZero,
      })}
    >
      <p
        className={classNames(`${ROOT_CLASSNAME}__subtotal`, {
          'mr-lg-auto mx-auto ml-md-0': isLessThanZero,
        })}
      >
        Cart Subtotal {subtotal}
      </p>

      <p className={`${ROOT_CLASSNAME}__free-delivery`}>{messaging}</p>
    </div>
  );
};

export default CartMessage;
